<template>
  <el-dialog
    width="500px"
    modal-append-to-body
    append-to-body
    custom-class="dialog_box"
    :title="edit ? '编辑账号' : '新建账号'"
    :visible.sync="visible"
    :before-close="beforeClose"
  >
    <el-form
      ref="userForm"
      :model="formData"
      :rules="formRules"
      size="small"
      label-position="right"
      label-width="80px"
      label-suffix=":"
    >
      <el-form-item label="企业" prop="enterpriseName" required v-if="!edit">
        <el-select
          clearable
          v-model="formData.enterpriseName"
          style="width: 100%"
        >
          <el-option
            v-for="e in enterpriseList"
            :key="e.enterpriseId"
            :label="e.enterpriseName"
            :value="e.enterpriseName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="账号名" prop="userName" required>
        <el-input
          v-model="formData.userName"
          maxlength="10"
          show-word-limit
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号" prop="phone" required>
        <el-input v-model="formData.phone"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input
          v-model="formData.email"
          auto-complete="new-password"
        ></el-input>
      </el-form-item>

      <el-form-item label="密码" prop="userPwd" :required="!edit">
        <div v-if="updatePwd && edit">
          <el-input
            v-model="formData.userPwd"
            type="password"
            auto-complete="new-password"
          >
            <el-button slot="append" @click="updatePwd = false">取消</el-button>
          </el-input>
        </div>
        <div v-if="edit && !updatePwd">
          <el-button type="primary" size="mini" plain @click="updatePwd = true">
            修改密码
          </el-button>
        </div>

        <el-input
          v-model="formData.userPwd"
          type="password"
          v-if="!edit"
          auto-complete="new-password"
        >
        </el-input>
      </el-form-item>

      <!-- <el-form-item label="密码" prop="userPwd" required>
        <el-input v-model="formData.userPwd" type="password"></el-input>
      </el-form-item> -->
      <el-form-item label="账号状态" prop="userStatus" required>
        <el-radio-group v-model="formData.userStatus">
          <el-radio :label="1">永久</el-radio>
          <el-radio :label="0">指定有效期</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="过期时间"
        prop="indate"
        v-if="formData.userStatus === 0"
      >
        <el-date-picker type="date" v-model="formData.indate"></el-date-picker>
      </el-form-item>
    </el-form>
    <div class="form_footer">
      <el-button size="small" @click="beforeClose">取消</el-button>
      <el-button size="small" type="primary" @click="submit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import formRules from "./rules";
export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    enterpriseList: {
      type: Array,
      default: () => [],
    },
    edit: {
      type: Boolean,
      defalut: false,
    },
    initFormData: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      formData: {
        userStatus: 1,
        userName: "",
        userPwd: "",
        enterpriseId: "",
        enterpriseName: "",
        phone: "",
        email: "",
        indate: "",
      },
      updatePwd: false,
    };
  },
  computed: {
    formRules() {
      return formRules(this.edit);
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.initData();
      }
    },
  },
  methods: {
    initData() {
      if (this.edit) this.formData = { ...this.initFormData, userPwd: "" };
    },
    submit() {
      this.$refs.userForm
        .validate()
        .then(() => {
          if (!this.edit) {
            this.formData.enterpriseId = this.enterpriseList.find(
              (t) => t.enterpriseName === this.formData.enterpriseName
            ).enterpriseId;
          }

          if (this.edit && (!this.formData.userPwd || !this.updatePwd)) {
            delete this.formData.userPwd;
          }
          if (this.formData.userStatus === 0) {
            this.formData.indate = this.$moment(this.formData.indate);
          }
          const url = this.edit ? "/user/update" : "/user/insert";
          this.$http({
            url,
            method: "post",
            data: this.formData,
          }).then((res) => {
            if (res.code === 200) {
              const message = this.edit ? "编辑成功" : "添加成功";
              this.$message({
                message,
                type: "success",
              });
              this.beforeClose();
            } else {
              this.$message({
                message: res.message,
                type: "error",
              });
            }
          });
        })
        .catch((err) => {
          console.log("表单校验失败");
        });
    },
    // 关闭前的回调
    beforeClose() {
      this.updatePwd = false;
      this.formData = {
        userStatus: 1,
        userName: "",
        userPwd: "",
        enterpriseId: "",
        enterpriseName: "",
        phone: "",
        email: "",
        indate: "",
      };
      this.$emit("update");
      this.$emit("close-modal");
      this.$refs.userForm.resetFields();
    },
  },
};
</script>

<style lang="scss">
.dialog_box {
  border-radius: 10px;
}
.form_footer {
  text-align: right;
}
</style>


// WEBPACK FOOTER //
// src/pages/index/views/accManage/userModal.vue